import { debug } from './constants/logType';

export interface IAppSettings {
    controllerName: string,
    actionName: string,
    hostName: string,
    currentUser: string,
    isAdmin: boolean,
    logType: number
};

const settings: IAppSettings = {
    controllerName: null,
    actionName: null,
    hostName: null,
    currentUser: null,
    isAdmin: false,
    logType: debug
};

interface GlobalAppHolder {
    GlobalAccess: { app: IAppSettings }
}

function lockAndLoadSettings(options) {
    Object.keys(options)
        .forEach((o) => {
            settings[o] = options[o]
        });
}

function loadPolyfills() {
    // TODO load polyfills
}

function init(options) {
    lockAndLoadSettings(options);
    loadPolyfills();
}

//let app = null;
const w = <GlobalAppHolder><any>window;

const AppSingleton = {
    init(config) {
        init(config);
        w.GlobalAccess.app = Object.freeze(settings);
    },
    /**
     * @returns {{controllerName: string, actionName: string, hostName: string, currentUser: string, isAdmin: boolean}}
     */
    getApp() {
        return w.GlobalAccess.app;
    }
}

export { AppSingleton };